import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconImperfections: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="imperfections">
    <path d="M12.6 9.4v4.2h-1.2V9.4h1.2ZM12.001 16.6a.6.6 0 1 0 0-1.2.6.6 0 0 0 0 1.2Z" />
    <path
      fillRule="evenodd"
      d="M11.105 3.79 3.724 18.552A1 1 0 0 0 4.618 20h14.764a1 1 0 0 0 .894-1.447L12.894 3.789a1 1 0 0 0-1.789 0Zm7.953 15.01L12 4.684 4.942 18.8h14.116Z"
    />
  </Icon>
);
